// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  API: "",
  offShoreAPI:
    "https://us-central1-customer-service-portal-325207.cloudfunctions.net/",
  devShoreAPI: "https://main-api-dev-245785768623.us-west2.run.app/",
  uatShoreAPI: "https://main-api-dev-245785768623.us-west2.run.app/",
  prodShoreAPI:
    "https://us-west2-center-store-inventory-prod.cloudfunctions.net/",
  ProdSiteURL: "csinventory.savemart.com",
  DevSiteURL: "csinventory-dev.savemart.com",
  UATSiteURL: "csinventory-dev.savemart.com",
  OffshoreSiteURL: "newitem-dev2.savemart.com",
  // redirectURLSSODev:'https://desktop.pingone.com/savemart/url?source=application&url=https%3A%2F%2Fsso.connect.pingidentity.com%2Fsso%2Fsp%2Finitsso%3Fsaasid%3De9180e2c-86b1-4cb7-84ee-9c2de78e70e7%26idpid%3Dcsinventory-dev.savemart.com&title=IDP%20Connection&applicationtype=APPLICATION_DEFAULT&saasid=e9180e2c-86b1-4cb7-84ee-9c2de78e70e7&newDock=true',
  // redirectURLSSOProd:'https://desktop.pingone.com/savemart/url?source=application&url=https%3A%2F%2Fsso.connect.pingidentity.com%2Fsso%2Fsp%2Finitsso%3Fsaasid%3Dad0d8fdb-a757-4512-b9b7-5b0e808120da%26idpid%3Dcsinventory.savemart.com&title=IDP%20Connection&applicationtype=APPLICATION_DEFAULT&saasid=ad0d8fdb-a757-4512-b9b7-5b0e808120da&newDock=true',

  redirectURLSSODev:
    "https://login.microsoftonline.com/880f5112-d912-4029-b742-b1edf8c834b1/oauth2/v2.0/authorize?client_id=852936fd-e9c5-4435-8eba-f6891f059480&response_type=code&redirect_uri=https://csinventory-dev.savemart.com&scope=openid",
  redirectURLSSOProd:
    "https://login.microsoftonline.com/880f5112-d912-4029-b742-b1edf8c834b1/oauth2/v2.0/authorize?client_id=b986bf4a-9ae3-479a-8898-679dd2ede3bf&response_type=code&redirect_uri=https://csinventory.savemart.com&scope=openid",

  verifyCSILogin: "verify-csi-login",
  getCSILibraryValues: "getCSILibraryValues",
  authenticateWithMyApps: "AuthenticateWithMyApps",
  authenticateWithNonMyapps:
    "https://main-api-dev-245785768623.us-west2.run.app/login/authenticate-with-nonmyapps",
  GetCSIInventoryDetailsByGroup: "GetCSIInventoryDetailsByGroup",
  GetCSIInventoryDashboardDetails: "GetCSIInventoryDashboardDetails",
  AddUpdateCSIDepartment: "AddUpdateCSIDepartment",
  GetCSIInventoryDetailsByGroups: "GetCSIInventoryDetailsByGroups",
  AddUpdateCSIUsers: "AddUpdateCSIUsers",
  AddUpdateDeleteCSIVendor: "AddUpdateDeleteCSIVendor",
  AddUpdateDeleteCSIVendorSchedule: "AddUpdateDeleteCSIVendorSchedule",
  uploadCSIVendorFiles: "bulk-import-csi-vendor-schedule",
  getCSIReportData: "getCSIReportData",
  GetCSIInventoryReportGroupDetails: "GetCSIInventoryReportGroupDetails",
  CreateInventoryCorrections: "createInventoryCorrections",
  ApproveRejectInventoryCorrections: "ApproveRejectInventoryCorrections",
  CSIResetUserPassword: "CSIResetUserPassword",
  AddCSINewUserRegister: "AddCSINewUserRegister",
  AddUpdateCSIUPCCorrection: "AddUpdateCSIUPCCorrection",
  authenticatePing: "AuthenticateWithPing",
  GetCSIInventoryDetails: "GetCSIInventoryDetails",
  GetCostSummary: "getCostSummary",
  GetUPCInfo: "getUPCInfo",
  submitMultipleInvCorrections: "submitMultipleInvCorrections",
  GetExcelCostSummary: "getExcelCostSummaryReport",
  getCSIUPCDetails: "getCSIUPCDetails",
  GetCSIInventorydetailsExcel: "GetCSIInventorydetailsExcel",
  Dcinvoice:
    "https://us-west2-tsmc-workbench-dev.cloudfunctions.net/getDcInvoice",
  storereceivinglogTableData: "getStoreReceivingLogs",
  getMasterData: "getMasterData",
  getDSDandSuperVendorInvoices: "getDSDandSuperVendorInvoices",
  uploadFileEndpoint:
    "https://storage.googleapis.com/upload/storage/v1/b/centrestore_inventoriesreport/o?uploadType=multipart",
  getCSIStoreReceivingLogs: "GetCSIStoreReceivingLogs",
  AddUpdateCSIStoreReceivingLogs: "AddUpdateCSIStoreReceivingLogs",
  ReadRebateFile: "ReadRebateFile",
  GetCSGrossProfitSummary: "GetCSGrossProfitSummary",
  GetCSIInventoryBalanceAndRebates: "GetCSIInventoryBalanceAndRebates",
  CSGrossProfitMatchandFinalize: "CSGrossProfitMatchandFinalize",
  GetCSGrossProfitSummaryExcelDownload: "GetCSGrossProfitSummaryExcelDownload",
  ReadGrossProfitSummary: "ReadGrossProfitSummary",
  GPMonthlyReport: "GPMonthlyReport",
  GrossProfitReports: "GrossProfitReports",
  GrossProfitMatchLog: "GrossProfitMatchLog",
  CSGrossProfitSummaryComments: "CSGrossProfitSummaryComments",
  ApproveInvoicePeriod: "ApproveInvoicePeriod",
  getGrossProfitMasterData: "getGrossProfitMasterData",
  GetRawInventoryExcelDownload: "getRawInventoryExcelDownload",
  GetMonthlyCutOffReportExcel: "GetMonthlyCutOffReportExcel",
  GetCSGrossProfitSummaryExcelDownloadALL:
    "GetCSGrossProfitSummaryExcelDownloadALL",
  SearchGetCSGrossProfitSummary:
    "https://us-west2-datawarehouse-322115.cloudfunctions.net/GetCSGrossProfitSummary",
  AddUpdateConfigType: "AddUpdateConfigType",
  ReadGrossImpact: "ReadGrossImpact",
  GetReportTypesList: "getreporttypeslist",
  ForcedInventoryExcelDownload: "ForcedInventoryExcelDownload",
  ForcedRetailGrossProfit: "forced-retail-gross-profit",
  ForcedReadGrossProfitSummary: "forced-read-gross-profit-summary",
  ForcedGPSummaryExcelDownloadALL: "forced-gp-summary-excel-download-all",
  ReadUploadType: "ReadUploadType",
  ReadForcedInvUIShrink: "readforcedinvuishrink",
  GetRollEntryReportExcelDownload: "GetRollEntryReportExcelDownload",
  GetReportType: "getCSILibraryValues",
  Reconciliation: "get-reconciliation-report-excel-download",
  Exceptionreport: "get-exception-report-excel-download",
  uploadCSIVendorFilesProd:
    "https://bulk-import-csi-vendor-schedule-1092806948147.us-west2.run.app",
};
